import React from "react";
import PropTypes from "prop-types";
import { Td } from "./Td";
import Return from "../Return";

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
const defaultProps = {
  /** return 的值 */
  children: "-"
};

export const TdRtn = props => {
  return (
    <Td {...props}>
      <Return rtn={props.children} />
    </Td>
  );
};

TdRtn.propTypes = propTypes;
TdRtn.defaultProps = defaultProps;

export default TdRtn;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Td/TdRtn.js